// src/utils/constants.ts
export const SOLANA_RPC_ENDPOINT = process.env.REACT_APP_RPC_URL || 'https://mainnet.helius-rpc.com/?api-key=37327d2d-9742-4fc4-b0d0-57d489b78697';

// RevShare Public API - No keys needed!
// The public API is free and doesn't require authentication
export const REVSHARE_PUBLIC_API = 'https://api.revshare.dev/public';
export const PROJECT_SLUG = 'aladdin-launchpad'; // Your unique project identifier

// Fee Structure
export const PLATFORM_FEE = 0.1; // SOL
export const LIQUIDITY_FEE = 1.0; // SOL
export const BUNDLER_FEE = 0.5; // SOL
export const STEALTH_MODE_FEE = 0.05; // SOL

// Commission Structure
export const REFERRAL_COMMISSION = 0.2; // 20%

// Network Detection
export const IS_MAINNET = SOLANA_RPC_ENDPOINT.includes('mainnet');
export const IS_DEVNET = SOLANA_RPC_ENDPOINT.includes('devnet');
export const IS_TESTNET = SOLANA_RPC_ENDPOINT.includes('testnet');

// Token Defaults
export const DEFAULT_TOKEN_DECIMALS = 9;
export const DEFAULT_LP_LOCK_PERCENTAGE = 100;

// UI Constants
export const BALANCE_REFRESH_INTERVAL = 30000; // 30 seconds
export const TOAST_DURATION = 3000; // 3 seconds

// Bundler Limits
export const MAX_BUNDLE_WALLETS = 100;
export const MIN_BUNDLE_WALLETS = 10;
export const MAX_BUNDLE_DELAY = 30; // seconds
export const MIN_BUNDLE_DELAY = 1; // seconds

// Sniper Bot Limits
export const MAX_SLIPPAGE = 50; // percent
export const MIN_SLIPPAGE = 1; // percent
export const MIN_SNIPE_AMOUNT = 0.01; // SOL